<template lang="pug">
  .report
    InputFile(label="arquivo escalas xls, xlsx" v-model="file" ref="inputFile"
      :allowedTypes="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']")

    PButton(color="success" size="md" @click="generate" :loading="loading" :disabled="!valid || !file") enviar

</template>

<script>
import InputFile from 'src/common/inputs/InputFile'

export default {
  components: {InputFile},
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      file: null
    }
  },
  methods: {
    getOptions () {
      return this.reportOptions
    },
    async generate () {
      if (!this.valid) return

      this.loading = true

      const compMan = this.$store.state.userInfo.compMan.id

      let typeImport

      if (
        window.location.href.includes('app.pontotel.com.br') ||
        window.location.href.includes('new-front.pontotel.com.br') ||
        window.location.href.includes('canary.pontotel.com.br') ||
        window.location.href.includes('gestao.pontotel.com.br')
      ) {
        typeImport = 'prod'
      } else if (
        window.location.href.includes('localhost') ||
        window.location.href.includes('front-local.pontotel.com.br')
      ) {
        typeImport = 'local'
      } else if (
        window.location.href.includes('homolog.pontotel.com.br') ||
        window.location.href.includes('hml.pontotel.com.br')
      ) {
        typeImport = 'homolog'
      } else {
        throw new Error('Invalid type for import afd')
      }

      const fileName = `escalas-${compMan}-${(new Date()).toISOString()}-${typeImport}`
      console.log(`file uploaded to google ${fileName}`)

      await this.$refs.inputFile.uploadToStorage('reports', fileName)
      console.log('upload finished')
      let result

      const params = {
        forceKind: 'True',
        fileKey: fileName
      }

      try {
        result = await this.$API.I02.save(params, params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;

  .flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
}
</style>
